import {
  AppBar,
  Toolbar,
  makeStyles,
  Button,
  IconButton,
  Drawer,
  MenuItem,
  Box,
  Container,
  Paper,
  Dialog,
  Hidden,
  Popper,
  Avatar,
  Typography,
  Select,
  Switch,
  withStyles,
  ClickAwayListener,
  useTheme,
} from "@material-ui/core";
import Menu from "@mui/material/Menu";
import { FaUserEdit } from "react-icons/fa";
import SettingsContext from "src/context/SettingsContext";
import SideBar from "src/layouts/DashboardLayout/SideBar/index";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Logo from "src/component/Logo";
import { FaChevronDown } from "react-icons/fa";
import { RiSettings4Line, RiBriefcase4Line } from "react-icons/ri";
import { CgClose } from "react-icons/cg";
import SearchField from "./SearchField";
import { NavLink } from "react-router-dom";
import ImageIconChecked from "./moon.svg";
import ImageIconUnchecked from "./sun.svg";
import { AuthContext } from "src/context/Auth";
import { generateUniqueAvatar } from "src/utils";
import wallet from "src/views/pages/Wallet";
import { signOut } from "../../../firebase";
import { toast } from "react-hot-toast";
import {
  postAPIHandler,
  getAPIHandler,
  patchAPIHandler,
  rawAPICall,
} from "src/Apiconfig/service";
import ApiConfig from "src/Apiconfig/config";
import { Box as MuiBox, CircularProgress, Typography as MuiTypography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import WhatsNewDrawer from "src/component/WhatsNewDrawer";

const WHATS_NEW_SEEN_KEY = "whatsNewLastSeenCount";
const WHATS_NEW_FEATURE_COUNT = 3; // keep in sync with FEATURES.length in WhatsNewDrawer.js
import { symbol } from "d3";
import { handleLogout } from "src/utils/authUtils";
const headersData = [
  {
    label: "Portfolio",
    href: "/secure/portfolio",
  },
  {
    label: "Wallets",
    href: "/secure/wallet",
  },
  {
    label: "Transactions",
    href: "/secure/transactions",
  },
  {
    label: "Tax Center",
    href: "/secure/tax",
  },
  {
    label: "Performance",
    href: "/secure/performance",
  },
  {
    label: "Tax Write-offs",
    href: "/secure/tax-write-offs",
  },
  // {
  //   label: 'Vote',
  //   href: '/vote',
  // },
];

const useStyles = makeStyles((theme) => ({
  customMenuList: {
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
  },
  listBox: {
    "&.MuiList-root-MuiMenu-list": {
      paddingTop: "0px !important",
      paddingBottom: "0px !important",
    },
  },
  appbar: {
    background: theme.palette.background.main,
    borderBottom: `1px solid ${theme.palette.background.border} !important`,
    borderRadius: 0,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,

    "&:hover": {
      backgroundColor: theme.palette.background.main,
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
    },
  },

  inputRoot: {
    borderRadius: theme.shape.borderRadius,
    paddingRight: theme.spacing(1),
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.bg4box,
  },

  grow: {
    flexGrow: 1,
  },
  menuButton: {
    color: `${theme.palette.secondary.main} !important`,
    marginRight: "20px",
    fontSize: "14px",
    fontWeight: "600",
    fontFamily: '"Manrope", Helvetica, Arial, sans-serif', // ✅ Ensure consistent font
    "&.active": {
      color: `${theme.palette.primary.main} !important`,
      position: "relative",
      fontWeight: "700", // ✅ Consistent bold weight for active state
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif', // ✅ Match Wallets active state
      "&::before": {
        content: '" "',
        position: "absolute",
        bottom: "-22px",
        left: "-1px",
        borderBottom: "2px solid #7d56e7",
        width: "100%",
        height: "2px",
        transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      },
    },
  },
  drawerContainer: { maxWidth: "95%", margin: "0 auto" },
  menuButton1: {
    width: "100%",
    padding: "6px 0",
    "& li": { width: "100%", borderRadius: "8px" },
  },
}));
const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 38,
    height: 22,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: "white",
    "&$checked": {
      transform: "translateX(16px)",
      color: "white",
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.background.main,
        borderColor: "transparent",
      },
    },
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: "none",
  },
  track: {
    borderRadius: 30,
    opacity: 1,
    backgroundColor: theme.palette.background.main,
    borderColor: "transparent",
  },
  checked: {},
}))(Switch);
export default function Header() {
  // Ideally this function should be renamed as Topbar for better understanding
  const [anchorEl, setAnchorEl] = useState(null);
  //const history = useHistory()
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);
  const themeSeeting = useContext(SettingsContext);
  const auth = useContext(AuthContext);
  const theme = useTheme();
  const { userData, setUserData } = auth;
  const [disableHeaders, setDisableHeaders] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [selectOpen, setSelectOpen] = useState(false);
  // Average sync progress across every currently-syncing wallet, shown as a small
  // circular badge next to the "Wallets" nav link so it's visible from any page -
  // not just the Wallets page itself, which already has its own per-wallet bars.
  const [navWalletSyncPercent, setNavWalletSyncPercent] = useState(null);
  const navWalletStatusPollRef = useRef(null);
  const [whatsNewOpen, setWhatsNewOpen] = useState(false);
  // The unseen dot compares against a count, not individual ids - simple enough for a short,
  // hand-maintained announcements list, and avoids needing per-entry read-state in localStorage.
  const [hasUnseenWhatsNew, setHasUnseenWhatsNew] = useState(() => {
    try {
      const lastSeenCount = parseInt(localStorage.getItem(WHATS_NEW_SEEN_KEY) || "0", 10);
      return lastSeenCount < WHATS_NEW_FEATURE_COUNT;
    } catch (e) {
      return false;
    }
  });
  const openWhatsNew = () => {
    setWhatsNewOpen(true);
    setHasUnseenWhatsNew(false);
    try {
      localStorage.setItem(WHATS_NEW_SEEN_KEY, String(WHATS_NEW_FEATURE_COUNT));
    } catch (e) {
      // localStorage can throw in private browsing - the dot just reappears next visit, harmless
    }
  };

  const getCountryList = async () => {
    try {
      const response = await getAPIHandler({
        endPoint: "country",
        //id: userData?.uid,
      });
      if (response.status === 200) {
        setCountryList(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching list of countries:", error);
    }
  };
  // Polls wallet sync status independently of the Wallets page (which may not be
  // mounted at all - this needs to show progress from any page) and derives one
  // overall percentage: the average of progressPercent across every wallet that
  // hasn't reached a terminal status yet. Wallets that don't report real progress
  // (progressPercent stays 0 - see SyncProgressTracker.NOOP) still count in the
  // average as 0, same as the per-card behavior on the Wallets page.
  const fetchNavWalletSyncStatus = useCallback(async () => {
    if (!auth?.userData?.uid) return;
    try {
      const response = await rawAPICall({
        method: "GET",
        url: `${ApiConfig["load"]}/status`,
      });
      if (response.status === 200) {
        const walletStatuses = response.data?.walletStatuses || [];
        const activeStatuses = walletStatuses.filter(
          (status) =>
            status.status !== process.env.REACT_APP_WALLET_SYNC_COMPLETED_SUCCESFULLY &&
            status.status !== process.env.REACT_APP_WALLET_SYNC_COMPLETED_ERROR &&
            status.status !== process.env.REACT_APP_WALLET_SYNC_COMPLETED_TIMEOUT
        );
        if (activeStatuses.length === 0) {
          setNavWalletSyncPercent(null);
        } else {
          const total = activeStatuses.reduce((sum, status) => sum + (status.progressPercent || 0), 0);
          setNavWalletSyncPercent(Math.round(total / activeStatuses.length));
        }
      }
    } catch (error) {
      console.error("Error fetching nav wallet sync status:", error);
    }
  }, [auth?.userData?.uid]);

  // One-time-per-session nudge: a regular (non-accountant) user has no other way to notice a
  // pending accountant invite short of clicking the shared link directly - this surfaces it once
  // per browser session so it isn't silently missed, without nagging on every page navigation.
  useEffect(() => {
    if (!auth?.userData?.uid) return;
    const sessionKey = `accountantInviteNudgeShown_${auth.userData.uid}`;
    try {
      if (sessionStorage.getItem(sessionKey)) return;
    } catch (e) {
      // sessionStorage can throw in private browsing - just skip the dedupe, worst case it
      // shows again this session
    }
    getAPIHandler({ endPoint: "accountantInvites" })
      .then((response) => {
        if (response.status === 200 && (response.data || []).length > 0) {
          const count = response.data.length;
          toast(
            (t) => (
              <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                <span>
                  You have {count} pending accountant invite{count > 1 ? "s" : ""}.
                </span>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  style={{ textTransform: "none" }}
                  onClick={() => {
                    toast.dismiss(t.id);
                    history.push("/secure/profile", { tab: "accountant_access" });
                  }}
                >
                  Review
                </Button>
              </Box>
            ),
            { duration: 10000 }
          );
          try {
            sessionStorage.setItem(sessionKey, "1");
          } catch (e) {
            // see above
          }
        }
      })
      .catch(() => {});
  }, [auth?.userData?.uid]);

  useEffect(() => {
    if (!auth?.userData?.uid) return;
    let cancelled = false;
    const poll = async () => {
      await fetchNavWalletSyncStatus();
      if (cancelled) return;
      // Same adaptive cadence as the Wallets page's own poll - fast while something
      // is actually in flight, slow otherwise so an idle session isn't hammering this.
      const delay = navWalletSyncPercent !== null ? 4000 : 60000;
      navWalletStatusPollRef.current = setTimeout(poll, delay);
    };
    poll();
    return () => {
      cancelled = true;
      clearTimeout(navWalletStatusPollRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.userData?.uid, fetchNavWalletSyncStatus, navWalletSyncPercent !== null]);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const updateUserPreferences = async (updatedPrefs) => {
    try {
      const matched = countryList.find(
        (item) => item.currency === updatedPrefs.preferredCurrency,
      );
      const payload = {
        preferredCurrency: updatedPrefs.preferredCurrency,
      };
      const response = await patchAPIHandler({
        endPoint: "userProfile",
        // id: `${auth.userData.uid}/preferences`,
        data: payload,
      });

      if (response.status === 200) {
        console.log("Preferences updated successfully");
        const updatedProfile = {
          ...auth.userProfileInfo,
          currency: updatedPrefs.preferredCurrency,
          symbol: matched?.symbol,
        };

        console.log("🔄 [Header] Updating profile with:", updatedProfile);
        auth.setUserProfileInfo(updatedProfile);

        toast.success("Currency updated successfully");
      } else {
        console.error("Error updating user preferences:", response);
      }
    } catch (error) {
      console.error("Error updating user preferences:", error);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = async () => {
    await handleLogout(auth);
  };

  const handleMenuItemClick = (path) => {
    history.push(path); // Navigate to the specified path
    handleMenuClose(); // Close the dropdown menu
  };

  const handleSubscriptionBillingClick = () => {
    history.push("/secure/profile", { tab: "subscription_billing" });
    handleMenuClose();
  };
  const helpSupport = () => {
    window.open("https://help.blockstats.app/", "_blank");
  };
  const changeTheme = (type) => {
    themeSeeting.saveSettings({
      theme: type,
    });
  };
  const [open1, setOpen1] = useState(false);
  const {
    menuMobile,
    menuButton,
    menuButton1,
    drawerContainer,
    drawericon,
    mainHeader,
  } = useStyles();
  const history = useHistory();

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  // const [currency, setCurrency] = React.useState(auth.userProfileInfo.currency ||'')
  const [currency, setCurrency] = React.useState("");

  const handleChange = async (event) => {
    const selectedCurrency = event.target.value;
    setCurrency(selectedCurrency);

    const selectedCountryData = countryList.find(
      (country) => country.currency === selectedCurrency,
    );

    if (selectedCountryData) {
      const updatedPrefs = {
        preferredCurrency: selectedCurrency,
      };

      await updateUserPreferences(updatedPrefs);

      auth.setUserProfileInfo((prev) => ({
        ...prev,
        currency: selectedCurrency,
        symbol: selectedCountryData.symbol,
      }));
    }
  };

  const { mobileView, drawerOpen } = state;
  //popper
  const [open, setOpen] = useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    // Defensive check
    if (!event || !event.target) {
      setOpen(false);
      return;
    }

    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    if (
      event.target.closest(".MuiSelect-root") ||
      event.target.closest(".MuiSelect-select") ||
      event.target.closest(".MuiSelect-selectMenu") ||
      event.target.closest(".MuiPaper-root")
    ) {
      return;
    }

    setOpen(false);
  };

  //popper
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 1280
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();
    getCountryList();

    // ✅ Pre-fill the selected country value if available
    // if (auth?.userProfileInfo?.currency) {
    //   setCurrency(auth.userProfileInfo.currency);
    // }

    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  /**
   * This check for user prefernces , if the user has not set any preferences we are making the API call and set the user preferences.
   */
  useEffect(() => {
    if (auth?.userProfileInfo?.currency) {
      setCurrency(auth.userProfileInfo.currency);
    }
  }, [auth.userProfileInfo]);
  useEffect(() => {
    if (auth.userProfileInfo == undefined) {
      console.log("User Profile Info is undefined");
      //auth.data.userProfileInfo
    }
  }, []);

  // useEffect(() => {
  //   // Ensure the select is set correctly if the userProfileInfo changes after load
  //   if (auth.userProfileInfo.currency !== currency) {
  //     setCurrency(auth.userProfileInfo.currency);
  //   }
  // }, [auth.userProfileInfo.currency, currency]);

  const { userAddedWallets } = useContext(AuthContext);
  console.log("Fetched wallets in userAddedWallets:", userAddedWallets);

  const displayDesktop = () => {
    return (
      <>
        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          style={{ width: "250px" }}
        >
          {femmecubatorLogo}
        </Box>
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          {getMenuButtons()}
        </Box>
        <div className={classes.grow} />
        <SearchField />
        <IconButton onClick={openWhatsNew} title="What's New" data-tour="whats-new">
          <MuiBox sx={{ position: "relative", display: "inline-flex" }}>
            <AutoAwesomeIcon style={{ color: "rgb(84 84 84)" }} fontSize="small" />
            {hasUnseenWhatsNew && (
              <MuiBox
                sx={{
                  position: "absolute",
                  top: -2,
                  right: -2,
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#F4A261",
                  border: `1.5px solid ${theme.name === "LIGHT" ? "#fff" : "#15131C"}`,
                }}
              />
            )}
          </MuiBox>
        </IconButton>
        <IconButton
          className="themeset"
          variant="contained"
          color="primary"
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <RiSettings4Line style={{ color: "rgb(84 84 84)" }} />
        </IconButton>
        <WhatsNewDrawer
          open={whatsNewOpen}
          onClose={() => setWhatsNewOpen(false)}
          isLightTheme={theme.name === "LIGHT"}
        />
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          transition
          placement="bottom-end"
          style={{ minWidth: "220px", marginTop: "10px", zIndex: 1300 }}
        >
          <ClickAwayListener
            onClickAway={(event) => {
              if (selectOpen) return; // Don't close Popper if Select is open

              if (
                anchorRef.current &&
                anchorRef.current.contains(event?.target)
              ) {
                return;
              }

              setOpen(false);
            }}
          >
            <Paper elevation={4}>
              <Box className="dflexBetween">
                <Typography variant="body2" color="secondary">
                  Theme
                </Typography>
                <CustomSwitch
                  icon={<img src={ImageIconUnchecked} alt="Unchecked Icon" />}
                  checkedIcon={
                    <img src={ImageIconChecked} alt="Checked Icon" />
                  }
                  checked={themeSeeting.settings.theme === "DARK"}
                  onChange={(event) => {
                    const newTheme = event.target.checked ? "DARK" : "LIGHT";
                    changeTheme(newTheme);
                  }}
                  color="primary"
                  inputProps={{ "aria-label": "Change Theme" }}
                />
              </Box>
              <Box my={2} className="dflexBetween">
                <Typography variant="body2" color="secondary">
                  Currency
                </Typography>
                <Select
                  IconComponent={FaChevronDown}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={currency}
                  onChange={handleChange}
                  onOpen={() => setSelectOpen(true)}
                  onClose={() => setSelectOpen(false)}
                >
                  {countryList
                    .filter((c) => c.enabled)
                    .map((country, index) => (
                      <MenuItem key={index} value={country.currency}>
                        <img
                          src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${country.currency}.png`}
                          alt={country.name}
                          style={{ width: 24, height: 16, marginRight: 8 }}
                        />
                        {country.currency}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
              {/* <Box className="dflexBetween">
                <Typography variant="body2" color="secondary">
                  Currency
                </Typography>
                <Select
                  IconComponent={FaChevronDown}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  onChange={handleChange}
                >
                  <MenuItem value={10}>Ten</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select>
              </Box>  */}
              <Box my={2} className="dflexBetween">
                <Typography variant="body2" color="secondary">
                  Cost Basis
                </Typography>
                <Box
                  style={{
                    padding: "6px 12px",
                    borderRadius: "8px",
                    fontSize: "13px",
                    color: "#83818E",
                    border: "1px solid #83818E",
                    minWidth: "80px",
                    textAlign: "right",
                    fontWeight: 600,
                    backgroundColor:
                      themeSeeting.settings.theme === "DARK"
                        ? "#1C1825"
                        : "#F7F7F8",
                    transition: "all 0.3s ease",
                  }}
                >
                  {auth?.userProfileInfo?.costBasisType || "—"}
                </Box>
              </Box>
            </Paper>
          </ClickAwayListener>
        </Popper>

        <Box>
          <>
            <Avatar
              style={{ marginLeft: "10px", cursor: "pointer" }}
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}/userAvatar.svg`}
              onClick={handleAvatarClick}
            />
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              classes={{ list: classes.customMenuList }}
              sx={{
                "& .MuiPaper-root": {
                  borderRadius: "8px !important",
                  backgroundColor:
                    themeSeeting.settings.theme === "DARK"
                      ? theme.palette.background.main
                      : "#fff",
                  marginTop: "10px", // Add spacing below the top bar
                },
              }}
            >
              <MenuItem onClick={() => handleMenuItemClick("/secure/profile")}>
                <Box display="flex" alignItems="center">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/profile.svg`}
                    alt="Profile"
                    style={{ width: 24, height: 24 }}
                  />
                  <Typography
                    variant="body2"
                    style={{
                      marginLeft: 10,
                      color: "#83818E",
                      fontFamily: '"Manrope", Helvetica',
                      fontSize: "12px",
                    }}
                  >
                    Profile Information
                  </Typography>
                </Box>
              </MenuItem>
              {auth?.userProfileInfo?.accountant && (
                <MenuItem onClick={() => handleMenuItemClick("/secure/accountant")}>
                  <Box display="flex" alignItems="center">
                    <RiBriefcase4Line size={20} color="#83818E" />
                    <Typography
                      variant="body2"
                      style={{
                        marginLeft: 10,
                        color: "#83818E",
                        fontFamily: '"Manrope", Helvetica',
                        fontSize: "12px",
                      }}
                    >
                      CPA Portal
                    </Typography>
                  </Box>
                </MenuItem>
              )}
              {/* <MenuItem onClick={() => handleMenuItemClick('/security')}>
          <Box display="flex" alignItems="center">
          <img
    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/security.svg`}
    alt="Profile"
    style={{ width: 24, height: 24 }}
  />
            <Typography variant="body2" style={{ marginLeft: 10 ,color:"#83818E",fontFamily:'"Manrope", Helvetica', fontSize:"12px"}}>
              Security Settings
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/notifications')}>
          <Box display="flex" alignItems="center">
          <img
    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/notification.svg`}
    alt="Profile"
    style={{ width: 24, height: 24 }}
  />
            <Typography variant="body2" style={{ marginLeft: 10,color:"#83818E",fontFamily:'"Manrope", Helvetica', fontSize:"12px" }}>
              Notification Preferences
            </Typography>
          </Box>
        </MenuItem> */}
              <MenuItem onClick={handleSubscriptionBillingClick}>
                <Box display="flex" alignItems="center">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/subscription.svg`}
                    alt="Profile"
                    style={{ width: 24, height: 24 }}
                  />
                  <Typography
                    variant="body2"
                    style={{
                      marginLeft: 10,
                      color: "#83818E",
                      fontFamily: '"Manrope", Helvetica',
                      fontSize: "12px",
                    }}
                  >
                    Subscription and Billing
                  </Typography>
                </Box>
              </MenuItem>
              {/* <MenuItem onClick={helpSupport}>
                <Box display="flex" alignItems="center">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/help.svg`}
                    alt="Profile"
                    style={{ width: 24, height: 24 }}
                  />
                  <Typography
                    variant="body2"
                    style={{
                      marginLeft: 10,
                      color: "#83818E",
                      fontFamily: '"Manrope", Helvetica',
                      fontSize: "12px",
                    }}
                  >
                    Help & Support
                  </Typography>
                </Box>
              </MenuItem> */}
              <MenuItem onClick={() => handleLogoutClick("/support")}>
                <Box display="flex" alignItems="center">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/logout.svg`}
                    alt="Profile"
                    style={{ width: 24, height: 24 }}
                  />
                  <Typography
                    variant="body2"
                    style={{
                      marginLeft: 10,
                      color: "#E74238",
                      fontFamily: '"Manrope", Helvetica',
                      fontSize: "12px",
                    }}
                  >
                    Logout
                  </Typography>
                </Box>
              </MenuItem>
            </Menu>
          </>
        </Box>
      </>
    );
  };
  const paperProps = {
    style: {
      top: "auto",
      bottom: 0,
    },
  };
  const displayMobile = () => {
    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));
    //mobile
    return (
      <Toolbar className={mainHeader} style={{ width: "100%" }}>
        <Hidden lgUp implementation="css">
          <Dialog
            fullScreen
            open={open1}
            anchor={"bottom"}
            onClose={() => setOpen1(false)}
          >
            <Box px={2}>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setOpen1(false)}
                aria-label="close"
              >
                <FaUserEdit />
              </IconButton>
              <SideBar />
            </Box>
          </Dialog>
        </Hidden>
        <Drawer
          {...{
            anchor: "right",
            open: drawerOpen,
            onClose: handleDrawerClose,
            PaperProps: paperProps,
          }}
        >
          <div className={drawerContainer}>
            <Box
              className="dflexBetween"
              style={{ position: "relative", padding: "10px" }}
            >
              <Logo />
              <IconButton
                edge="start"
                color="secondary"
                onClick={handleDrawerClose}
                aria-label="close"
                className="closeButtonDrawer"
              >
                <CgClose style={{ color: "#83818E" }} />
              </IconButton>
            </Box>
            <Box>
              <SideBar />
            </Box>
            {getDrawerChoices()}

            {auth?.userProfileInfo?.accountant && (
              <Button
                color="inherit"
                to="/secure/accountant"
                component={Link}
                className={menuButton1}
                onClick={handleDrawerClose}
              >
                <MenuItem className={menuMobile}>CPA Portal</MenuItem>
              </Button>
            )}

            <Box className="drawerbox"></Box>
          </div>
        </Drawer>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{ width: "100%" }}
        >
          <Box display="flex" justifyContent="space-between">
            {femmecubatorLogo}
          </Box>
          <Box display="flex" alignItems="center">
            <IconButton
              className={drawericon}
              {...{
                edge: "start",
                color: "inherit",
                "aria-label": "menu",
                "aria-haspopup": "true",
                onClick: handleDrawerOpen,
              }}
            >
              <MenuIcon
                width="60px"
                height="60px"
                style={{ color: "#83818E", fontSize: "26px" }}
              />
            </IconButton>
          </Box>
        </Box>
      </Toolbar>
    );
  };

  const getDrawerChoices = () => {
    return headersData.map(({ label, href }, index) => {
      // Hide "Tax Center" if user country is USA
      // if (
      //   label === 'Tax Center' &&
      //   (auth?.userProfileInfo?.name === 'USA' || auth?.userProfileInfo?.name === 'United States of America')
      // ) {
      //   return null;
      // }
      const isDisabled = disableHeaders && index < 4;
      return (
        <Button
          key={label}
          color="inherit"
          to={isDisabled ? "#" : href}
          component={Link}
          className={`${menuButton1} ${isDisabled ? "disabled" : ""}`}
          style={isDisabled ? { pointerEvents: "none", opacity: 0.5 } : {}}
        >
          <MenuItem className={menuMobile}>{label}</MenuItem>
        </Button>
      );
    });
  };

  const femmecubatorLogo = (
    <Box>
      <Link to="/">
        <Logo className="logoImg" />
      </Link>
    </Box>
  );

  const getMenuButtons = () => {
    return headersData.map(({ label, href }) => {
      // Hide "Tax Center" if user country is USA
      // if (
      //   label === 'Tax Center' &&
      //   (auth?.userProfileInfo?.name === 'USA' || auth?.userProfileInfo?.name === 'United States')
      // ) {
      //   return null;
      // }
      return (
        <NavLink
          exact
          key={label}
          color="inherit"
          to={href}
          className={classes.menuButton}
          activeClassName="active"
          style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
        >
          {label}
          {label === "Wallets" && navWalletSyncPercent !== null && (
            <MuiBox
              title={`Syncing wallets: ${navWalletSyncPercent}%`}
              sx={{
                position: "relative",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 30,
                height: 30,
                flexShrink: 0,
              }}
            >
              {/* Thin, clearly separate track + arc (was a thick 4.5px ring on a
                  30-34px circle, which visually filled in as a solid peach disc
                  rather than reading as a ring) - a slim 3px stroke with a neutral
                  gray track and a saturated orange arc keeps the two distinguishable
                  at this small size. */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={3}
                sx={{ position: "absolute", color: theme.name === "LIGHT" ? "#E3E3E6" : "#3A3545" }}
              />
              <CircularProgress
                variant="determinate"
                value={navWalletSyncPercent}
                size={30}
                thickness={3}
                sx={{ position: "absolute", color: "#F4A261" }}
              />
              <MuiTypography
                sx={{
                  fontSize: "9px",
                  fontWeight: 700,
                  lineHeight: 1,
                  color: theme.name === "LIGHT" ? "#3A3545" : "#FFFFFF",
                }}
              >
                {navWalletSyncPercent}%
              </MuiTypography>
            </MuiBox>
          )}
        </NavLink>
      );
    });
  };

  return (
    <>
      <AppBar position="relative" elevation={0} className={classes.appbar}>
        <Container maxWidth={false} style={{ padding: "0px" }}>
          <Toolbar> {mobileView ? displayMobile() : displayDesktop()}</Toolbar>
        </Container>{" "}
      </AppBar>
      {dialogOpen && (
        <Paper>
          <Dialog
            fullWidth
            maxWidth="lg"
            className={classes.searchdiaogBox}
            style={{
              position: "absolute",
              top: "10%",
              // minHeight: "695px",
            }}
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
          >
            <IconButton
              className="closeButton"
              onClick={() => setDialogOpen(false)}
            >
              <CloseIcon style={{ color: "#AAAAAA" }} />
            </IconButton>

            <Box className="dialogBoxHeight">
              <CloseIcon style={{ color: "#AAAAAA" }} />
            </Box>
          </Dialog>
        </Paper>
      )}
    </>
  );
}
